import {
  every,
  filter,
  findIndex,
  isEmpty,
  isEqual,
  isNil,
  some,
} from 'lodash';
import {
  IDiscovery,
  IFocusedDataPoint,
} from '../../../discovery/interfaces/discovery.interface';

interface IFocusedData {
  label: string;
}
interface Action {
  data: IFocusedData[];
  multiSelectEnabled: boolean;
}

export const updateFocusedGroupData = (
  activeDiscovery: IDiscovery,
  action: Action,
): {
  focusedData: IFocusedData[];
  focusedDataPoints: IFocusedDataPoint[];
} => {
  if (isNil(activeDiscovery)) {
    return {
      focusedData: [],
      focusedDataPoints: [],
    };
  }
  let { focusedData = [], focusedDataPoints = [] } = activeDiscovery;
  const newItems = action.data;

  if (isEmpty(newItems)) {
    focusedData = [];
  } else if (action.multiSelectEnabled) {
    newItems.forEach(item => {
      const index = findIndex(focusedData, d => isEqual(d, item));
      if (index === -1) {
        focusedData.push(item);
      } else {
        focusedData.splice(index, 1);
      }
    });
  } else {
    const allMatch =
      focusedData.length === newItems.length &&
      every(newItems, item => some(focusedData, fd => isEqual(fd, item)));
    focusedData = allMatch ? [] : [...newItems];
  }
  if (!isEmpty(focusedData)) {
    focusedDataPoints = filter(focusedDataPoints, point =>
      some(focusedData, pathInfo => isEqual(point.pathInfo, pathInfo)),
    );
  }
  return {
    focusedData,
    focusedDataPoints,
  };
};
